<template>
  <v-row
    :class="
      listingTask.id || isInvestor
        ? 'justify-space-between flex-wrap no-gutters align-center'
        : 'align-start'
    "
  >
    <v-col v-if="expense.paid_at" class="mb-2" cols="auto">
      <p class="text-caption mb-0">Approved at</p>
      <span class="font-weight-medium">{{ parseDate(expense.paid_at) }}</span>
    </v-col>
    <v-col v-if="listingTask.moved_to_done_at" class="mb-2" cols="auto">
      <p class="text-caption mb-0">Done at</p>
      <span class="font-weight-medium">{{
        parseDate(listingTask.moved_to_done_at)
      }}</span>
    </v-col>
    <v-col v-if="listingTask.total_hours" class="mb-2" cols="auto">
      <p class="text-caption mb-0">Total hours</p>
      <span class="font-weight-medium">{{ listingTask.total_hours }}</span>
    </v-col>
    <v-col v-if="createdByName" class="mb-2" cols="auto">
      <p class="text-caption mb-0">Created by</p>
      <span class="font-weight-medium"> {{ createdByName }} </span>
    </v-col>
    <v-col
      v-if="listingTask.amount || mainExpense.amount"
      class="mb-2"
      cols="auto"
    >
      <p class="text-caption mb-0">
        {{ listingTask.id ? 'Labor' : 'Expense Amount' }}
      </p>
      <div class="font-weight-medium">
        {{ toMoney(listingTask.id ? listingTask.amount : mainExpense.amount) }}
      </div>
      <div
        v-if="!listingTask.id && mainExpense.vat"
        class="text-caption grey--text mt-1"
      >
        VAT: {{ toMoney(mainExpense.vat)
        }}<span v-if="mainExpense.vat_rate">
          ({{ mainExpense.vat_rate }}%)</span
        >
      </div>
      <div v-if="vat" class="text-caption grey--text mt-1">
        VAT: {{ toMoney(vat) }}<span v-if="vat_rate"> ({{ vat_rate }}%)</span>
      </div>
    </v-col>
    <v-col v-if="!listingTask.id && mgmtFeeExpense" class="mb-2" cols="auto">
      <p class="text-caption mb-0">Management Fee</p>
      <div class="font-weight-medium">
        {{ toMoney(mgmtFeeExpense.amount) }}
      </div>
      <div v-if="mgmtFeeExpense.vat" class="text-caption grey--text mt-1">
        VAT: {{ toMoney(mgmtFeeExpense.vat)
        }}<span v-if="mgmtFeeExpense.vat_rate">
          ({{ mgmtFeeExpense.vat_rate }}%)</span
        >
      </div>
    </v-col>
    <v-col v-if="materialsSum" class="mb-2" cols="auto">
      <p class="text-caption mb-0">Total Material cost</p>
      <div class="font-weight-medium">
        {{ toMoney(materialsSum) }}
      </div>
      <div v-if="materialsVat" class="text-caption grey--text mt-1">
        VAT: {{ toMoney(materialsVat)
        }}<span v-if="materialsVatRate"> ({{ materialsVatRate }}%)</span>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import CommonFunctions from 'components/mixins/common_functions'
import PermissionsMixin from 'components/mixins/permissions-mixin'
import FormattersMixin from 'components/mixins/formatters-mixin'
import { sumBy } from 'lodash/fp'
import { mapState } from 'vuex'
export default {
  mixins: [CommonFunctions, PermissionsMixin, FormattersMixin],
  props: {
    expense: {
      type: Object,
      default: () => ({}),
    },
    listingTask: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState(['accountingData']),
    currentExpense() {
      return (
        this.accountingData?.expenses?.find(ex => ex.id === this.expense.id) ||
        this.expense
      )
    },
    createdByName() {
      return !this.isInvestor && this.currentExpense.created_by_name
    },
    // Main expense is either this expense (if not mgmt fee) or its parent
    mainExpense() {
      if (
        this.currentExpense.is_mgmt_fee_expense &&
        this.currentExpense.parent_expense
      ) {
        return this.currentExpense.parent_expense
      }
      return this.currentExpense
    },
    // Mgmt fee expense is either this expense (if it is mgmt fee) or its child
    mgmtFeeExpense() {
      if (this.currentExpense.is_mgmt_fee_expense) {
        return this.currentExpense
      }
      // Find the management fee child expense
      return this.currentExpense.child_expenses?.find(
        child => child.is_mgmt_fee_expense
      )
    },
    materialsSum() {
      return sumBy('amount', this.listingTask.material_expenses)
    },
    materialsVat() {
      return sumBy(e => +e.vat, this.listingTask.material_expenses)
    },
    vat() {
      return this.listingTask?.expense?.vat
    },
    vat_rate() {
      return this.listingTask?.expense?.vat_rate
    },
    materialsVatRate() {
      const firstMaterial = this.listingTask.material_expenses?.[0]
      return firstMaterial?.vat_rate || null
    },
    totalCost() {
      return (
        (this.listingTask.amount || 0) +
        (this.materialsSum || 0) +
        (this.listingTask.management_fee || 0)
      )
    },
  },
}
</script>
